// components/V3/CinemaBookingOption/index.jsx
import React from "react";
import Button from "@components/Ui/Button";
import Spinner from "@components/Ui/Spinner";

const CinemaBookingOption = ({
                                 hasUserClicked,
                                 selectedOption,
                                 isPolling,
                                 showLoader,
                                 showCinemaFees,
                                 cinemaBookingFee,
                                 cinemaUpgradeFee,
                                 quantity = 1,
                                 onOptionSelect,
                             }) => (
                                 <div className="terms-drawer__wrapper">
                                     <h2 className="terms-drawer__title">Reserve Seats</h2>
                                     <p className="terms-drawer__text">We&#39;ve reserved movie vouchers for your session.</p>
                                     <p className="terms-drawer__text">
                                         Select &#34;Book with Cinema&#34;, our AI Agent will complete the booking with the cinema on your behalf
                                         (best available seats selected, booking fees apply).
                                     </p>
                                     <p className="terms-drawer__text">OR</p>
                                     <p className="terms-drawer__text">
                                         Select &#34;Take the Vouchers&#34;, you can take your vouchers and show them at the box office
                                         (no booking fees apply)
                                     </p>

                                     <div className="terms-drawer__button-wrapper">
                                         <div className="terms-drawer__buttons">
                                             <Button
                                                 additionalClasses={`button button__secondary terms-drawer__button ${hasUserClicked && selectedOption === "cinema" ? "active" : ""}`}
                                                 onClick={() => onOptionSelect("cinema")}
                                                 disabled={isPolling}
                 >
                                                 Book with Cinema
                                             </Button>
                                             <Button
                                                 additionalClasses={`button button__secondary terms-drawer__button ${hasUserClicked && selectedOption === "vouchers" ? "active" : ""}`}
                                                 onClick={() => onOptionSelect("vouchers")}
                                                 disabled={isPolling}
                 >
                                                 Take the Vouchers
                                             </Button>
                                         </div>
                                         {showLoader && <Spinner text="retrieving booking fees" center={true} />}
                                     </div>

                                     {showCinemaFees && (
                                     <div className="terms-drawer__fees">
                                         <p className="terms-drawer__fee-item">
                                             Cinema Booking Fee: ${((cinemaBookingFee ?? 0) * (Number(quantity) || 1)).toFixed(2)}
                                         </p>
                                         <p className="terms-drawer__fee-item">
                                             Cinema Upgrade Fee: ${(cinemaUpgradeFee ?? 0).toFixed(2)}
                                         </p>
                                     </div>
         )}
                                 </div>
);

export default CinemaBookingOption;
